import { render, staticRenderFns } from "./ParentsImport.vue?vue&type=template&id=1f9fb940&"
import script from "./ParentsImport.vue?vue&type=script&lang=js&"
export * from "./ParentsImport.vue?vue&type=script&lang=js&"
import style0 from "./ParentsImport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports